// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"HeroBlockSlice_imageContainer__WhBw0","imageDesktop":"HeroBlockSlice_imageDesktop__0WH9o","imageMobile":"HeroBlockSlice_imageMobile__XJcuy"};